<template>
  <v-container v-if="!loading">
    <v-card flat>
      <!-- provide an option to login manually -->
      <v-card-text style="margin:auto; text-align:center;" v-if="!user">
        <h3>Voting Disabled</h3>
        <!--<Login />-->
      </v-card-text>
      <v-card-text v-else>
        <div class="text-center">
          <ToolBar v-if="user" />
        </div>
        <div class="text-center" v-if="status === 'filtered'">
          <div
            style="margin:auto; height: 200px; width: 320px; position:fixed; top:0; bottom:0; left:0; right:0; color:#777; font-size:16px;"
          >
            <div
              style="text-align:center; padding:10px; border:1px solid #bbb;"
            >
              {{ reason }}
            </div>
          </div>
        </div>
        <div
          class="text-center"
          v-if="status === 'waiting' || $socket.disconnected"
        >
          <PollGraphic />
          <!--<img width="120px" src="../assets/pollsicon.png" alt="Polls" />-->
        </div>
        <div
          style="text-align:center; margin: 130px auto;"
          v-if="$socket.disconnected"
        >
          <v-btn small color="primary" @click="connectToServer()"
            >Connect to Polls</v-btn
          ><br />
          <p class="pt-3">
            <a
              target="_blank"
              :href="`https://app.agmify.com/live/?tk=${$store.state.token}`"
              >open in new browser tab</a
            >
          </p>
        </div>
        <v-card-text v-else>
          <div v-if="activePoll">
            <!-- using a key forces the component to refresh -->
            <DisplayPoll
              v-bind:key="activePoll._id"
              v-if="status === 'ready'"
            />
          </div>
          <div v-if="status === 'closed'">
            <v-card-subtitle
              class="justify-center text-center"
              style="word-break: normal; font-weight:600"
              >{{ activePoll.pollText }}</v-card-subtitle
            >
            <v-divider class="pb-m1"></v-divider>
            <div class="text-center">
              The poll is now closed.
              <span v-if="activePoll.showResults !== 'hide' || user.scrutineer"
                >Displaying results.</span
              >
            </div>

            <VoteResults
              v-if="activePoll.showResults !== 'hide' || user.scrutineer"
              :poll="activePoll"
              :voteResponse="voteResponse"
            />
            <div class="text-center" v-else>
              The poll is now closed. Results are being hidden by the
              moderator.<br /><strong
                >You answered:
                {{
                  history.has(activePoll._id)
                    ? history.get(activePoll._id).voteResponse.join(", ")
                    : "no response"
                }}</strong
              >
            </div>
          </div>
        </v-card-text>
      </v-card-text></v-card
    ></v-container
  >
</template>
<script>
// @ is an alias to /src
//import client from '@/services/axios';
import ToolBar from "@/components/ToolBar/ToolBar.vue";
import PollGraphic from "@/components/ToolBar/PollGraphic.vue";
import DisplayPoll from "@/components/DisplayPoll.vue";
import VoteResults from "@/components/Results/VoteResults.vue";
import { mapState } from "vuex";

export default {
  name: "LivePoll",
  components: {
    ToolBar,
    PollGraphic,
    DisplayPoll,
    VoteResults
  },
  data() {
    return {
      loading: false,
      reason: "",
      status: "", // waiting, ready, submitted, edit, closed
      //activePoll: null,
      voteResponse: "",
      voteResponsePrevious: "",
      socket: {},
      loginRequired: false,
      errors: []
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      event: (state) => state.event,
      history: (state) => state.history,
      activePoll: (state) => state.activePoll
    })
  },
  async created() {
    this.loading = true;
    await this.$store.dispatch("getHistory");
    if (!this.isAllowed()) this.status = "filtered";

    // if (this.activePoll)
    //   if (
    //     this.activePoll.tags.length &&
    //     !this.filterTags(this.activePoll.tags)
    //   ) {
    //     this.status = 'filtered';
    //   }
    this.loading = false;
  },

  methods: {
    /**
     * If authentication is required prevent the poll from displaying
     * to guests and staff roles.
     * Next we check if the poll has any tags and they are matched with users
     *
     */
    isAllowed() {
      if (this.activePoll) {
        if (this.activePoll.requireAuth) {
          if (this.user.role === "guest" || this.user.role === "staff") {
            this.reason =
              "* You are not eligible to vote on this poll. Please standby.";
            return false;
          }
        }
        if (
          this.activePoll.tags.length &&
          !this.filterTags(this.activePoll.tags)
        ) {
          this.reason =
            "** You are not eligible to vote on this poll. Please standby.";
          return false;
        }
      }
      return true;
    },
    filterTags(tags) {
      if (this.user.tags.length) {
        return this.user.tags.filter((tag) => tags.includes(tag));
      }
      return false;
    },
    async displayPoll(poll) {
      this.$store.commit("SET_ACTIVE_POLL", poll);
      if (!this.isAllowed()) this.status = "filtered";
      else this.status = "ready";
    },
    connectToServer() {
      this.$socket.client.open();
      this.$socket.client.emit("JOIN_VOTERS", this.user);
    }
  },
  sockets: {
    connect_error(reason) {
      this.errorMessage = reason;
      console.log("VOTE REJECTED", reason.message);
    },

    connect() {
      this.status = "waiting";
      console.log("User connected");
    },
    disconnect() {
      // handle disconnects

      console.log("User Disconnected");
    },
    reconnect() {
      // handle reconnects
      console.log("User Reconnected");
      this.$socket.client.emit("JOIN_VOTERS", this.user);
    },
    async displayPollToUser(data) {
      await this.displayPoll(data);
    },
    closePollToUser() {
      this.status = "closed";
    },
    closeResultsToUser() {
      this.status = "waiting";
      this.$store.commit("SET_ACTIVE_POLL", null);
    },
    toggleScrutineer(state) {
      // reload when scrutineer is toggled.
      this.user.scrutineer = state;
      // this.$store.commit('setUser', {
      //   ...this.user,
      //   scrutineer: state
      // });
      //this.$router.go();
    }
  }
};
</script>
<style>
.v-input--selection-controls {
  margin-top: 10px;
  padding-top: 5px;
}

.container {
  padding: 0 !important;
}

.v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 7px;
}

html {
  overflow: auto;
}
</style>
